import $ from 'jquery';
import {
  config,
  A11yHelpers,
  AjaxEmailForm,
  CookiesNotice,
  Flash,
  Popover,
  SocialShareButton,
  Subscribe,
} from '@shopify/marketing-assets';

export default function initializeMarketingAssets() {
  config.set('customGoogleAnalyticsNamespace', '_exchange');

  new Flash();
  new A11yHelpers();
  new CookiesNotice();

  $('.js-popover').each((i, el) => {
    new Popover($(el));
  });

  $('.js-social-share').each((i, el) => {
    new SocialShareButton($(el));
  });

  $('.js-ajax').each((i, el) => {
    new AjaxEmailForm($(el));
  });

  $('.js-subscribe').each((i, el) => {
    new Subscribe($(el));
  });
}
